module.exports = require("vuex");